import { z } from 'zod';
import { getDataTypeSchema } from '../mw/getDataTypes';

const getMWParamListValue = z.array(
  z.object({
    id: z.string(),
    mwParamId: z.string(),
    name: z.string(),
    listValue: z.string(),
  })
);

export const getMWParamsSchema = z.array(
  z.object({
    id: z.string(),
    mwDataTypeId: z.string(),
    mwParamGroupId: z.string(),
    companyId: z.string().optional(),
    code: z.string(),
    name: z.string(),
    remarks: z.string().optional(),
    defaultValue: z.string().optional(),
    isBinaryAllowed: z.boolean(),
    isNullAllowed: z.boolean(),
    isMobileAllowed: z.boolean(),
    mwParamGroup: z
      .object({
        id: z.string(),
        mwModuleID: z.string(),
        name: z.string(),
        gridPosition: z.number(),
      })
      .optional(),
    mwDataType: getDataTypeSchema.optional(),
    mwParamListValues: getMWParamListValue.optional(),
  })
);

export type GetMWParamsResponse = z.infer<typeof getMWParamsSchema>;
